import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ReactECharts from 'echarts-for-react';
import { outwriteTaskToEchartsOption } from '../outwrite/outwriteChartAdapter';
import { LEARNER } from '../outwrite/learnerTokens';

/**
 * Stem + chart card for learner practice (mockup left column).
 */
export default function OutwriteLearnerChartCard({ task }) {
  const stem = task?.given?.data?.stem || '';
  const option = outwriteTaskToEchartsOption(task);

  return (
    <Box
      component="section"
      aria-label="Task"
      sx={{
        flex: '1 1 480px',
        minWidth: 0,
        bgcolor: LEARNER.surface,
        border: `1px solid ${LEARNER.outlineVariantSoft}`,
        borderRadius: '12px',
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        boxSizing: 'border-box',
      }}
    >
      {stem ? (
        <Typography
          sx={{
            m: 0,
            fontSize: 16,
            lineHeight: '24px',
            color: LEARNER.onSurface,
          }}
        >
          {stem}
        </Typography>
      ) : null}
      {option ? (
        <Box sx={{ width: '100%', maxWidth: 640 }}>
          <ReactECharts
            option={option}
            style={{ height: 360, width: '100%' }}
            opts={{ renderer: 'canvas' }}
            notMerge
          />
        </Box>
      ) : (
        <Typography color="text.secondary">Chart unavailable.</Typography>
      )}
    </Box>
  );
}
